// removed by extract-text-webpack-plugin
module.exports = {"InputCaptcha":"InputCaptcha__InputCaptcha___18bbe","message":"InputCaptcha__message___1_WV7","messageShow":"InputCaptcha__messageShow___3U2Oy"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/InputCaptcha/InputCaptcha.less
// module id = 1352
// module chunks = 0 1